import { o_util, win } from "../common/namespaces";
import type { GlobalUtils } from "../exports";
import type { OttoNexus } from "../lib/nexus";

/**
 *
 */
export type CoreSync = GlobalUtils["core"];

/**
 *
 */
export const coreSync: CoreSync = o_util.core;

/**
 *
 */
export type CoreAsync = OttoNexus["grcore"];

/**
 *
 */
export const coreAsync: CoreAsync = win.otto.grcore;